// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useContext, useEffect, Fragment, SyntheticEvent,
    ComponentClass} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import cn from 'classnames';
import zurl from '/util/url.js';
import zutil from '/util/util.js';
// @ts-ignore
import {App_context} from '../context.js';
import {use_hidden} from './use_hidden';
import {open_store} from './install_btn';
import {Button, t_button_size} from '../lib/button';
import hopt from 'hola_opt';
import styles from './banner.module.less';
import {use_browser} from '../lib/use_browser';
import {Settings_context} from '../settings_ctx';
import www_util from 'hola_pub_util';
import {use_qs} from '../lib/use_qs';
import {Link} from './link';

const Banner_more = props=>{
    const {ref, clickid, discount_percent = 75} = props;
    return <div className={styles.more}>
      <Link className={styles.plan} to={`/premium?ref=${ref}&plan=1y`}
        data-clickid={`${clickid}_plan`}>
        <p className={styles.plan_title}>
          <span>Hola Premium</span> Annual plan
          {discount_percent && <span className={styles.plan_off}>
            {` `}{discount_percent}% OFF</span>}
        </p>
        <p className={styles.plan_price}>
          <b>$4.08</b> <span>/ month</span>
        </p>
        <p className={styles.plan_discount}>
          <span>$179.88</span> $49 for the first year<sup>*</sup>
        </p>
      </Link>
      <div className={styles.more_img}/>
    </div>;
};

interface i_banner {
    id?: string;
    title?: string|string[]|JSX.Element;
    show?: boolean;
    text?: string|JSX.Element;
    btn_text?: string;
    clickid?: string;
    btn_size?: t_button_size;
    href?: string;
    on_close?: ()=>void;
    on_click?: (ev?: SyntheticEvent)=>void;
    More?: ComponentClass;
}

const use_banner = (banner_id: string): i_banner=>{
    const browser = use_browser();
    // @ts-ignore
    const {inited, user, has_ext, is_plus,
    // @ts-ignore
        is_client} = useContext(App_context);
    const [hidden, hide] = use_hidden(true);
    const [banner, set_banner] = useState<i_banner>({});
    const history = useHistory();
    const {search, pathname} = useLocation();
    const qs_o = zurl.qs_parse(search.substr(1), {safe: true});
    const browser_flow = hopt.www_hola.promo_enabled_browsers || [];
    const special_offer = {
            title: 'Limited offer!',
            text: <Fragment>
              Get Hola Premium and see all the amazing
              features Hola has to offer.<br/>Now with <b>75% OFF!</b>
            </Fragment>,
            btn_text: 'Claim offer',
            on_close: ()=>set_banner({}),
    };
    const is_signup_active = ['/', '/sites'].includes(pathname) && has_ext
        && !user;
    const banners: i_banner[] = [
        {
            id: 'yesvember',
            title: <Fragment>November? <span>YES</span>vember!</Fragment>,
            text: <Fragment>
              To celebrate, how about a month of Hola Premium<br/> <b>unlimited
              VPN time</b> for free when you buy a month's subscription?
            </Fragment>,
            btn_text: 'Get a Free Month!',
            href: '/premium?plan=1y&ref=yesvember&form=true&'+
                'utm_source=HP&utm_medium=HP&utm_campaign=Yesvember&'+
                'utm_id=Yesvember&utm_content=Yesvember',
            clickid: 'yesvember',
            show: zutil.get(hopt, 'www_hola.banners.yesvember.enabled') &&
                !is_plus && !hidden.includes('yesvember') ||
                qs_o.debug_ui=='yesvember',
        },
        {
            ...special_offer,
            id: 'popular_welcome_banner',
            href: `/premium?ref=popular_welcome_email&plan=1y`,
            show: false && !is_plus && pathname=='/access/popular'
                && qs_o.ref=='welcome_email',
            clickid: 'popular_welcome_promo',
            More: Banner_more.bind(null, {ref: 'popular_welcome_email',
                clickid: 'popular_welcome_promo'}),
        },
        {
            ...special_offer,
            id: 'email_verify_banner',
            href: '/premium?plan=1y&ref=verify_email',
            show: false && !is_plus && !!qs_o.email_verify_success,
            clickid: 'verify_banner',
            More: Banner_more.bind(null, {ref: 'verify_email',
                clickid: 'verify_banner'}),
        },
        {
            id: 'ext_install_banner',
            title: 'Do you want to access a website?',
            text: 'Hola\'s extension will help you do so, in 2 simple '
                +'steps!',
            btn_text: 'Get Hola - It\'s free!',
            btn_size: 'md',
            on_click: ()=>open_store(),
            show: false && ['/', '/sites'].includes(pathname) && !!user
                && !has_ext && browser_flow.includes(browser),
            on_close: ()=>set_banner({}),
        },
        {
            id: 'signup_banner',
            title: 'You\'ve installed Hola.  Now get the full experience.',
            text: <Fragment>For a complete Hola experience, we
              invite you to create a free account.</Fragment>,
            btn_text: 'Create an account - it\'s free!',
            btn_size: 'md',
            on_click: ev=>{
                ev.preventDefault();
                history.push('/', {need_signup: true});
            },
            show: false && is_signup_active
                && !hidden.includes('signup_banner'),
        },
        {
            id: 'products_banner',
            title: ['On any device:', 'at home or on-the-go.'],
            text: <Fragment>
              Discover the best service for your favorite
              gadgets. Enjoy fast and stable access anywhere.
            </Fragment>,
            btn_text: 'Claim offer',
            href: '/premium?plan=1y&ref=products_page',
            clickid: 'products_page',
            show: false && pathname == '/products' && !is_plus &&
                !hidden.includes('products_banner'),
            More: Banner_more.bind(null, {ref: 'products_page',
                clickid: 'products_page'}),
        },
        {
            id: 'plus_setup_banner',
            title: ['On any device:', 'at home or on-the-go.'],
            text: <Fragment>
              Discover the best service for your favorite
              gadgets. Enjoy fast and stable access anywhere.
            </Fragment>,
            btn_text: 'Claim offer',
            href: '/premium?plan=1y&ref=plus_setup_page',
            clickid: 'plus_setup_page',
            show: false && pathname == '/plus_setup' && !is_plus &&
                !hidden.includes('plus_setup_banner'),
            More: Banner_more.bind(null, {ref: 'plus_setup_page',
                clickid: 'plus_setup_page'}),
        },
    ];
    useEffect(()=>{
        if (!inited)
            return;
        const _banner = banner_id && banners.find(({id})=>id==banner_id) ||
            banners.find(({show})=>show) || {};
        const delay = zutil.get(hopt,
            `www_hola.banners.${banner_id||_banner.id}.delay`, 500);
        setTimeout(()=>{ set_banner(_banner); }, delay);
    }, [inited, hidden]);
    const hide_banner = ()=>hide(banner.id);
    if (!is_client && (!banner || !banner.id))
    {
        const ssr_banner = banner_id && banners.find(({id})=>id==banner_id) ||
            banners.find(({show})=>show) || {};
        return {...ssr_banner, on_close: ssr_banner.on_close || hide_banner};
    }
    return {...banner, on_close: banner.on_close || hide_banner};
};

const Banner = props=>{
    const {id, title, text, btn_text, on_close, on_click, href, More,
        clickid, btn_size='sm'} = use_banner(props.banner_id);
    const cls = cn('container-fluid', styles.wrapper, styles[id]);
    const {theme} = useContext(Settings_context);
    const {no_banner} = use_qs();
    useEffect(()=>{
        if (clickid)
            www_util.perr({id: `www_banner_show_${clickid}`});
    }, [clickid]);
    if (no_banner)
        return <Fragment></Fragment>;
    return !!id && <div className={cls}>
      <div className={theme.container}>
        <div className={styles.hp_banner}>
          <div className={styles.content}>
            {More && <More/>}
            <div className={styles.title}>{Array.isArray(title) ?
                title.map((t, i, a)=><Fragment key={i}>
                  {t}{i<a.length-1 && <br/>}
                </Fragment>) : title}
            </div>
            <p className={styles.text}>{text}</p>
            <Button round arrow on_click={on_click} to={href} cls={styles.btn}
              clickid={`${clickid}_btn`} caption={btn_text} size={btn_size}/>
          </div>
          <div className={styles.close} onClick={on_close}/>
        </div>
      </div>
    </div>;
};

export {Banner};
